import fp from 'lodash/fp';
import { createSelector } from 'reselect';

export const getInventoryTagsView = fp.get('views.inventory.tags');

export const getIsSaving = createSelector(
  getInventoryTagsView,
  fp.get('saving')
);

export const getIsSaved = createSelector(getInventoryTagsView, fp.get('saved'));

export const getShowAddTagsModal = createSelector(
  getInventoryTagsView,
  fp.get('showAddTagsModal')
);
